import React from "react";
import "./../../css/HomeServices.css";
import Heading from "./../../ui/heading";
import ServiceAccordion from "../../ui/ServiceAccordion";
import { HiArrowUpRight } from "react-icons/hi2";
import { AccordionShape } from "../../assets/images";
import {
  Services1,
  Services2,
  Services3,
  Services4,
} from "../../assets/images";

const HomeServices = () => {
  return (
    <section className='home-services-section'>
      <div className='home-services-container'>
        <Heading variant='H2' className='home-services-heading'>
          Our Services
        </Heading>
        <div className='home-services-accordion'>
          <ServiceAccordion items={SERVICE_ITEMS} />
        </div>
      </div>
    </section>
  );
};

const SERVICE_ITEMS = [
  {
    title: "Air Pollution Control & Baghouse Services",
    order: "01",
    content: (
      <div className='service-item'>
        <div className='service-item-text'>
          <p className='service-item-description'>
            Upgrade outdated baghouse systems to more efficient configurations
            tailored to current process demands, regulations, or air quality
            goals.
          </p>
          <img src={AccordionShape} className='service-item-shape' alt='' />
          <HiArrowUpRight className='service-item-icon' />
        </div>
        <div className='service-item-image-container'>
          <img src={Services1} className='service-item-image' alt='' />
        </div>
      </div>
    ),
  },
  {
    title: "Engineering Evaluations",
    order: "02",
    content: (
      <div className='service-item'>
        <div className='service-item-text'>
          <p className='service-item-description'>
            Comprehensive technical assessments to evaluate the performance,
            design, and compliance of your dust collection or filtration system.
          </p>
          <img
           src={AccordionShape}
            className='service-item-shape'
            alt=''
          />
          <HiArrowUpRight className='service-item-icon' />
        </div>
        <div className='service-item-image-container'>
          <img src={Services2} className='service-item-image' alt='' />
        </div>
      </div>
    ),
  },
  {
    title: "Master Service Contracts",
    order: "03",
    content: (
      <div className='service-item'>
        <div className='service-item-text'>
          <p className='service-item-description'>
            Long-term, bundled service agreements tailored for clients with
            multiple sites or recurring needs, offering priority response and
            discounted rates.
          </p>
          <img
            src={AccordionShape}
            className='service-item-shape'
            alt=''
          />
          <HiArrowUpRight className='service-item-icon' />
        </div>
        <div className='service-item-image-container'>
          <img src={Services3} className='service-item-image' alt='' />
        </div>
      </div>
    ),
  },
  {
    title: "Preventive Maintenance Plans",
    order: "04",
    content: (
      <div className='service-item'>
        <div className='service-item-text'>
          <p className='service-item-description'>
            Planned service routines designed to extend equipment life, ensure
            compliance, and minimize costly unplanned downtime.
          </p>
          <img
            src={AccordionShape}
            className='service-item-shape'
            alt=''
          />
          <HiArrowUpRight className='service-item-icon' />
        </div>
        <div className='service-item-image-container'>
          <img src={Services4} className='service-item-image' alt='' />
        </div>
      </div>
    ),
  },
];

export default HomeServices;
